<template>
  <div class="container">
    <title-bar title="THIS FEATURE IS NOT UP TO DATE OR CURRENTLY BEING DEVELOPED"/>
    <div class="invisible card m-2">
      <div class="card-header d-flex">
        Medical Alley Association Job Board Maintenance
        <div class="ml-auto">
          <router-link class="btn btn-sm btn-danger" :to="{ name: 'Job Post', params: { id: 'create' } }">
            CREATE A JOB POST
          </router-link>
        </div>
      </div>
    </div>
    <div class="invisible card m-2">
      <div class="card-header">
        Search Job Postings
      </div>
      <div class="card-body d-flex">
        <div class="d-flex flex-fill">
          <b-form-input class="m-1" placeholder="Job Title" v-model="filter.title"></b-form-input>
          <b-form-input class="m-1" placeholder="Hiring Organization" v-model="filter.organization"></b-form-input>
          <button class="btn btn-danger m-1" @click="setJobs">Submit</button>
          <button class="btn btn-outline-dark m-1" @click="resetJobs">Reset</button>
        </div>
      </div>
    </div>

    <div class="invisible card m-2">
      <div class="card-header d-flex align-items-center">
        Showing {{ jobListings.length }} Postings
        <div class="ml-auto p-2">
          <button class="btn btn-sm btn-outline-dark mr-1" :disabled="this.filter.pageNumber === 0" @click="previousPage"><i class="fas fa-chevron-left"></i></button>
          <button class="btn btn-sm btn-outline-dark" @click="nextPage"><i class="fas fa-chevron-right"></i></button>
        </div>
      </div>
      <transition name="fade">
        <div v-if="!isLoaded" class="d-flex justify-content-center">
          <div class="spinner-border text-dark m-4" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </transition>
      <b-table striped hover :items="jobListings" :fields="fields" >
        <template v-slot:cell(job_title)="data">
          <router-link :to="{ name: 'Job Post', params: { id: data.item.id } }">
            {{ data.value }}
          </router-link>
        </template>
        <template v-slot:cell(date_posted)="data">
          {{ data.value | formatDate }}
        </template>
        <template v-slot:cell(is_approved)="data">
          {{
            data.value === 1 ? "Approved": data.value === 0 ? "Not Approved": "Rejected"
          }}
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import JobBoardAPI from '../../api/jobBoard'
import TitleBar from '../homePage/TitleBar.vue'
export default {
  components: { TitleBar },
  name: 'job-board-component',
  data: function () {
    return {
      isLoaded: false,
      jobListings: [],
      fields: [
        {key: 'organization_name', label: 'Organization'},
        {key: 'job_title', label: 'Job Title'},
        {key: 'date_posted', label: 'Date Created'},
        {key: 'is_approved', label: 'Approval Status', 'class': 'text-center'}
      ],
      filter: {
        pageNumber: 0
      }
    }
  },
  methods: {
    resetJobs () {
      this.filter = {
        pageNumber: 0
      }
      this.setJobs()
    },
    setJobs () {
      this.isLoaded = false
      this.jobListings = []
      JobBoardAPI.getPage(this.filter).then(
        response => {
          this.isLoaded = true
          this.jobListings = response.data.data.results
        }, issue => {}
      )
    },
    nextPage () {
      this.filter.pageNumber++
      this.setJobs()
    },
    previousPage () {
      this.filter.pageNumber--
      this.setJobs()
    }
  },
  mounted () {
    this.resetJobs()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/jobBoard/JobBoardIndex.vue